import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from "../interfaces/user.interface";
import { City } from "../interfaces/city.interface";
import { map, Observable, tap } from "rxjs";
import {State} from "../interfaces/state.interface";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) { }

  getUser(): Observable<User> {
    return this.httpClient.get<User>(`${this.apiUrl}/users`);
  }

  updateUser(user: User): Observable<User> {
    return this.httpClient.put<User>(`${this.apiUrl}/users`, user)
        .pipe(
            tap((response: any) => (response)),
            map((response: any) => response.data)
        );
  }

  getState(): Observable<State[]> {
    return this.httpClient.get<State[]>(`${this.apiUrl}/users/states`);
  }

  getCitiesByState(stateId: number): Observable<City[]> {
    return this.httpClient.get<City[]>(`${this.apiUrl}/users/cities?idUf=${stateId}`);
  }

  changePassword(oldPassword: string, newPassword: string, confirmNewPassword: string): Observable<any> {
    const body = {
      oldPassword,
      newPassword,
      confirmNewPassword
    };
    return this.httpClient.post<any>(`${this.apiUrl}/users/password`, body);
  }

}